import React, { useCallback, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import moment from 'moment'
import uuid from 'uuid/v4'
import './uploadImage.scss'
import { useTranslation } from 'react-i18next'
import StorageService from '@services/StorageApiClient'

const UploadImage = ({ onChange, limitMbs = 1, urlImageBD, alertMD }) => {
  const [urlImage, setUrlImage] = useState()
  const storageService = new StorageService()
  const { t } = useTranslation()
  const sizeMb = 1054105

  if (!urlImage && urlImageBD) setUrlImage(urlImageBD)

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles[0].size <= limitMbs * sizeMb) {
      let timeStamp = moment().utc().format('YYYYMMDDHHmmss')
      let key = `${timeStamp}_${uuid()}`
      if (
        acceptedFiles[0].type === 'image/jpeg' ||
        acceptedFiles[0].type === 'image/png' ||
        acceptedFiles[0].type === 'image/x-icon'
      ) {
        storageService.publicUpload(key, acceptedFiles[0]).then((url) => {
          console.log(url, ' url')
          onChange(url)
          setUrlImage(url)
        })
      } else {
        alertMD && alertMD(t('invalidImageFormat'))
      }
    } else {
      alertMD && alertMD(t('exceedsMaximumWeight'))
    }
  }, [])
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })

  return (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      {urlImage ? (
        <div className="imageWrapper">
          <img className="imageDroped" src={urlImage} />
        </div>
      ) : (
        <div className="dropzoneWrapper">
          <svg
            width="24"
            height="21"
            viewBox="0 0 24 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="dropzoneIcon"
          >
            <path d="M9.00024 6.75C9.00024 7.34674 8.76319 7.91903 8.34123 8.34099C7.91928 8.76295 7.34698 9 6.75024 9C6.15351 9 5.58121 8.76295 5.15925 8.34099C4.7373 7.91903 4.50024 7.34674 4.50024 6.75C4.50024 6.15326 4.7373 5.58097 5.15925 5.15901C5.58121 4.73705 6.15351 4.5 6.75024 4.5C7.34698 4.5 7.91928 4.73705 8.34123 5.15901C8.76319 5.58097 9.00024 6.15326 9.00024 6.75Z" />
            <path d="M3 0C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V18C0 18.7956 0.316071 19.5587 0.87868 20.1213C1.44129 20.6839 2.20435 21 3 21H21C21.7956 21 22.5587 20.6839 23.1213 20.1213C23.6839 19.5587 24 18.7956 24 18V3C24 2.20435 23.6839 1.44129 23.1213 0.87868C22.5587 0.316071 21.7956 0 21 0H3ZM21 1.5C21.3978 1.5 21.7794 1.65804 22.0607 1.93934C22.342 2.22064 22.5 2.60218 22.5 3V12.75L16.8345 9.8295C16.6938 9.75904 16.5346 9.73459 16.3792 9.75963C16.2239 9.78466 16.0804 9.85791 15.969 9.969L10.404 15.534L6.414 12.876C6.26994 12.7801 6.09714 12.737 5.92491 12.7539C5.75267 12.7709 5.5916 12.8468 5.469 12.969L1.5 16.5V3C1.5 2.60218 1.65804 2.22064 1.93934 1.93934C2.22064 1.65804 2.60218 1.5 3 1.5H21Z" />
          </svg>
          <p className="dropzoneText">Click to upload</p>
        </div>
      )}
    </div>
  )
}

export default UploadImage
